import { PORTAL_SERVICOS_BACKEND } from '../constants/environment';
import axios from '../http/axios';

export default {
	carregarConfiguracoesIniciais: () => {
		return axios
			.get(`${PORTAL_SERVICOS_BACKEND}/configuracoes/frontend`, {
				headers: { 'Cache-Control': 'no-cache' }
			})
			.then(res => {
				return res.data;
			});
	},
	carregar: payload => {
		return axios
			.get(`${PORTAL_SERVICOS_BACKEND}/configuracoes?chaves=${payload.chaves}`, {
				headers: { 'Cache-Control': 'no-cache' }
			})
			.then(res => {
				return res.data;
			});
	},
	atualizar: (tipo, chave, body, headers) => {
		return axios
			.post(`${PORTAL_SERVICOS_BACKEND}/configuracoes/${tipo}/${chave}`, body, { headers })
			.then(res => {
				return res.data;
			});
	}
};
